import { gql } from "lib/apolloClient";
import {
  curriculumProgramFragment,
  attachmentFragment,
} from "modules/CommonFragments";

export const organizationFragment = {
  organisationFeedDetails: gql`
    fragment organisationFeedDetailsItem on Organization {
      id
      name
      logo
      code
      isPaid
      region
      organizationAnalytics
      curriculumPrograms(filters: $curriculumProgramFilters) {
        id
        type
        label
        acronym
        platformId
        programType
        students {
          totalCount
        }
        isFeatureFlagLearningCoursesEnabled
        isAdminPortalGradingSetupV2Enabled
        staff {
          totalCount
        }
        buddy {
          firstName
          lastName
          id
          email
        }
        ... on UBDCurriculumProgram {
          variant
        }
        ... on IbDpCurriculumProgram {
          examSessionMonth
        }
        academicProgram {
          id
        }
        ...subscriptionPlanDetailsItem
        curriculumProgramData {
          subscriptionPlan
          subscriptionStatus
          curriculumGroup
          contractStaffCount
          contractStudentCount
          contractUserCount
          crmId
          updatedAt
        }
      }
    }
    ${curriculumProgramFragment.subscriptionPlanDetails}
  `,
  organizationAttachmentDetails: gql`
    fragment organizationAttachmentDetailsItem on Organization {
      id
      attachments {
        ...attachmentBasicDetailsItem
      }
    }
    ${attachmentFragment.basicDetails}
  `,
  organizationDetails: gql`
    fragment organizationDetailsItem on Organization {
      id
      academicYears {
        id
        startDate
        endDate
        isCurrentAcademicYear
      }
      constants {
        examSessionMonth
        scheduler
      }
      curriculumPrograms {
        rosteringMethod
        id
        programDataLanguages
        dealId
        ... on IbDpCurriculumProgram {
          examSessionMonth
        }
      }
    }
  `,
  organizationList: gql`
    fragment organizationItem on Organization {
      id
      name
      logo
      code
      toddleBuddy
      isPaid
      attachments {
        ...attachmentBasicDetailsItem
      }
      currentAcademicYear {
        startDate
        endDate
      }
      academicYears {
        id
        startDate
        endDate
        isCurrentAcademicYear
      }
      constants {
        examSessionMonth
        scheduler
        additionalData
      }
      courses {
        totalCount
      }
      staff {
        totalCount
      }
      students {
        totalCount
      }
      tier {
        plan
      }
      curriculumPrograms {
        id
        type
        rosteringMethod
        label
        acronym
        dealId
        platformId
        buddy {
          firstName
          lastName
          id
        }
        ... on IbDpCurriculumProgram {
          examSessionMonth
        }
        ...subscriptionPlanDetailsItem
        onboardingSteps {
          step
          status
        }
        programDataLanguages
        ...curriculumProgramBasicDetailsItem
      }
    }
    ${curriculumProgramFragment.subscriptionPlanDetails}
    ${curriculumProgramFragment.curriculumProgramBasicDetails}
    ${attachmentFragment.basicDetails}
  `,
  organizationBasicDetails: gql`
    fragment organizationItem on Organization {
      id
      name
      logo
      code
      attachments {
        ...attachmentBasicDetailsItem
      }
    }
    ${attachmentFragment.basicDetails}
  `,
};
